import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Container = styled.section`
  padding: 24px 16px 40px 16px;

  ${({ theme }) => `
    ${theme.breakpoints.desktop} {
      padding: 80px 117px;
    }
  `}
`

export const PaymentStepHeading = styled.h2`
  display: none;
  ${({ theme }) => css(theme.typographys.xl.bold)}
  color: ${({ theme }) => theme.colors.neutrals.b};
  margin-bottom: 16px;
  ${({ theme }) => `
    ${theme.breakpoints.desktop} {
      display: block;
    }
  `}
`
